
import React from 'react';
import { Helmet } from 'react-helmet';

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import CookiePolicy from '../components/cookiepolicy';
const CookiePolicyPage = (props) => {
  return (
    <div className='container'>
            <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Cysigil Network Pvt Ltd" />
        <link
          rel="canonical"
          href="https://www.cysigil.com"
        />
      </Helmet>
      <Navigation />
        <CookiePolicy />
        <Footer />
    </div>
      
  );
};

export default CookiePolicyPage;
